<template>
  <base-action-button @action="load">
    <template #prepend><PhUserPlus style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
    {{ $store.getters.translate("send_login_credentials") }}
  </base-action-button>
  <base-draggable-modal
      name="base_create_user"
      max-height="80vh"
      width="50vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="base_create_user">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate("send_login_credentials") }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-text-field
                density="default"
                class="reg-normal text-primary mt-3"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.email"
                hide-details
                flat
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('email') }}<strong>*</strong></span>
              </template>
            </v-text-field>
            <v-textarea
                density="default"
                class="reg-normal text-primary mt-3"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.message"
                hide-details
                flat
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('message') }}</span>
              </template>
            </v-textarea>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="closeModal('base_create_user');">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("close") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhPaperPlaneRight style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("send") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import { PhPaperPlaneRight, PhUserPlus, PhX } from "@phosphor-icons/vue";

export default {
  components: { BaseActionButton, BaseModal, BaseDraggableModal, PhX, PhPaperPlaneRight, PhUserPlus },
  props: ["person"],
  data() {
    return {
      record: {},
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.record = {
        email: this.person.emailaddresses && this.person.emailaddresses.length > 0 ? this.person.emailaddresses[0].emailaddress : null,
        person_id: this.person.id,
        message: null,
      };
      this.openModal('base_create_user');
    },
    async save() {
      await helpFunctions.postCustomRoute(this.$toast, "user/create", this.record, true, true);
      this.$emit('refresh');
      this.closeModal('base_create_user');
    },
  },
};
</script>